/**
 * MINHA ATENÇÃO AGORA — laudos que exigem ação
 * Fonte: /api/laudos/listar.php (não concluídos)
 */
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Loader2, Bell } from 'lucide-react';

export default function AtencaoAgoraCard() {
  const [laudos, setLaudos]   = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate              = useNavigate();

  useEffect(() => {
    fetch('/api/laudos/listar.php', { credentials: 'include' })
      .then(r => r.json())
      .then(d => {
        if (d.success) {
          // Pega os não-concluídos, ordena pelo mais antigo
          const ativos = (d.laudos || []).filter(
            l => l.status !== 'CONCLUIDO' && l.status !== 'ENCERRADO'
          );
          setLaudos(ativos);
        }
      })
      .catch(err => console.error('[AtencaoAgora]', err))
      .finally(() => setLoading(false));
  }, []);

  if (loading) {
    return (
      <div className="bg-[#0A0F1E] border border-white/[0.06] rounded-2xl p-6 flex justify-center">
        <Loader2 className="animate-spin text-blue-400" size={20} />
      </div>
    );
  }

  return (
    <div className="bg-[#0A0F1E] border border-blue-500/20 rounded-2xl p-6 shadow-[0_0_30px_rgba(59,130,246,0.05)]">

      <div className="flex items-center gap-3 mb-6">
        <div className="w-8 h-8 rounded-lg bg-blue-500/10 border border-blue-500/20 flex items-center justify-center">
          <Bell size={14} className="text-blue-400" />
        </div>
        <div>
          <h3 className="text-[10px] font-bold text-blue-400 uppercase tracking-[0.2em]">
            Minha Atenção Agora
          </h3>
          <p className="text-[9px] text-slate-500 uppercase tracking-wider mt-0.5">
            {laudos.length} laudo{laudos.length !== 1 ? 's' : ''} aguardando ação
          </p>
        </div>
      </div>

      {laudos.length === 0 ? (
        <div className="text-center py-8">
          <p className="text-emerald-400 text-xs font-bold uppercase tracking-widest">
            ✓ Tudo em ordem
          </p>
          <p className="text-slate-500 text-[10px] mt-2">
            Nenhum laudo requer sua atenção agora.
          </p>
        </div>
      ) : (
        <div className="space-y-2 max-h-[320px] overflow-y-auto pr-1">
          {laudos.map(l => (
            <button
              key={l.id}
              onClick={() => navigate(`/laudos/${l.codigo_mh}/abertura`)}
              className="w-full flex items-start gap-3 p-3 rounded-xl bg-white/[0.02] hover:bg-white/[0.04] border border-white/[0.04] text-left transition-all"
            >
              <div className="w-2 h-2 rounded-full bg-blue-400 mt-1.5 shrink-0" />
              <div className="min-w-0 flex-1">
                <p className="text-white font-bold text-sm truncate">
                  {l.codigo_mh || `#${l.id}`}
                </p>
                <p className="text-slate-500 text-[10px] uppercase tracking-wider mt-0.5">
                  {l.status?.replace(/_/g, ' ') || '—'}
                </p>
              </div>
            </button>
          ))}
        </div>
      )}

    </div>
  );
}